<div class="user-login-container">
  <form [formGroup]="signupForm" (submit)="onCrematoriumSignupSubmit(signupForm)">
    <h4>Crematorium Registration Form</h4>
    <div class="row white-box">
      <div class="col-md-4">
        <label>Full Name</label>
        <mat-form-field appearance="outline">
          <input type="text" formControlName="fullname" matInput placeholder="Enter full name" required />
          <mat-error *ngIf="requiredValidation(formControls['fullname'])">Full name is required.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <label>Mobile No.</label>
        <mat-form-field appearance="outline">
          <input type="text" formControlName="mobileNo" matInput placeholder="Enter Mobile Number" required />
          <mat-error *ngIf="requiredValidation(formControls['mobileNo'])">Mobile number is required.</mat-error>
          <mat-error *ngIf="patternValidation(formControls['mobileNo'])">Enter valid phone number</mat-error>
          <mat-error *ngIf="lengthValidation(formControls['mobileNo'])">Phone number should be 9 to 12 digits </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <label>Country</label>
        <ng-select appearance="outline" [items]="countryList" placeholder="Select Country" bindLabel="name"
          bindValue="id" (change)="getStateList($event)" formControlName="country"  required></ng-select>
      </div>

      <div class="col-md-4">
        <label>State</label>
        <ng-select appearance="outline" [items]="stateList" placeholder="Select State" bindLabel="state" bindValue="id"
          required (change)="getCityList($event)" formControlName="state"></ng-select>
      </div>

      <div class="col-md-4">
        <label>City</label>
        <ng-select appearance="outline" [items]="cityList" placeholder="Select City" bindLabel="city" bindValue="id"
          required (change)="getZipList($event)" formControlName="city"></ng-select>
      </div>

      <div class="col-md-4">
        <label>Zip Code</label>
        <ng-select appearance="outline" [items]="zipList" placeholder="Select ZipCode" bindLabel="zipCode" bindValue="zipCode"
          required formControlName="zip"></ng-select>
      </div>

      <div class="col-md-4">
        <label>Email Address</label>
        <mat-form-field appearance="outline">
          <input type="text" formControlName="email" matInput placeholder="Enter Email Address" required />
          <mat-error *ngIf="requiredValidation(formControls['email'])">Email is required.</mat-error>
          <mat-error *ngIf="patternValidation(formControls['email'])">Enter valid email address</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <label>Password</label>
        <mat-form-field appearance="outline">
          <input #passwordRef type="password" formControlName="password" matInput placeholder="Enter Password"
            required />
          <mat-error *ngIf="requiredValidation(formControls['password'])">Password is required</mat-error>
        </mat-form-field>
        <password-strength-meter [password]="signupForm.get('password').value" minPasswordLength="6">
        </password-strength-meter>
      </div>

      <div class="col-md-4">
        <label>Confirm Password</label>
        <mat-form-field appearance="outline">
          <input type="password" formControlName="confirmPassword" matInput placeholder="Enter Confirm Password"
            required />
          <mat-error *ngIf="requiredValidation(formControls['confirmPassword'])">Confirm password is required
          </mat-error>
          <mat-error *ngIf="signupForm.controls['confirmPassword'].hasError('NoPassswordMatch')">
            Passwords does not match
        </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-12">
        <label>Address</label>
        <mat-form-field appearance="outline">
          <textarea formControlName="address" matInput placeholder="Enter Address"></textarea>
        </mat-form-field>
      </div>

      <div class="col-md-12 MB-10 text-center">
        <button type="submit" [disabled]="!signupForm.valid" mat-raised-button class="black-btn" color="primary">
          Register
        </button>
      </div>
    </div>

    <div class="col-md-12 sign-up-link text-center">
      <span>Do you have an account? <a [routerLink]="loginUrl">Login</a></span>
    </div>
  </form>
</div>

